export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  appName: import.meta.env.VITE_APP_NAME,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  isLocal: import.meta.env.VITE_APP_ENV === 'local',
  isStaging: import.meta.env.VITE_APP_ENV === 'staging',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',
  posOfflineEnabled: import.meta.env.VITE_POS_OFFLINE_ENABLED === 'true',
  posOfflineBranchIds: (import.meta.env.VITE_POS_OFFLINE_BRANCH_IDS ?? '')
    .split(',')
    .map((value) => Number(value.trim()))
    .filter((value) => Number.isInteger(value) && value > 0),
}

export function isPosOfflineEnabledForBranch(branchId: number): boolean {
  return (
    env.posOfflineEnabled &&
    Number.isInteger(branchId) &&
    branchId > 0 &&
    (env.posOfflineBranchIds.length === 0 || env.posOfflineBranchIds.includes(branchId))
  )
}
